(function () {
  function getLinkText(el) {
    var aria = el.getAttribute('aria-label');
    if (aria && aria.trim()) return aria.trim();

    var tag = el.tagName.toLowerCase();
    if (tag === 'input') {
      var v = (el.value || '').trim();
      if (v) return v;
      var al = el.getAttribute('aria-label');
      return al ? al.trim() : '';
    }

    var text = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
    if (text) return text;

    var title = el.getAttribute('title');
    return title ? title.trim() : '';
  }

  function pushLinkClick(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'link_click' }, payload));
  }

  document.addEventListener(
    'click',
    function (event) {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

      var target = event.target;
      if (!(target instanceof Element)) return;

      var el = target.closest(
        'a[href], button, input[type="button"], input[type="submit"], input[type="reset"]'
      );
      if (!el) return;

      pushLinkClick({
        link_text: getLinkText(el),
      });
    },
    true
  );
})();
